// @flow
import {BaseApi} from 'modules/api/base';

class GameVarsApi extends BaseApi {
    constructor(slaveHost, password) {
        super();
        this.url = slaveHost || '';
        this.clusterAuth = password
            ? {
                  'X-CLUSTER-AUTH': password,
              }
            : {};
    }
    startGameTimer() {
        return this.put(this.url + '/api/v1/game-process/pass-tutorial', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    getGameVars() {
        return this.get(this.url + '/api/v1/game-process/game-vars', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    goNextStage(data: {mapId: number, timer?: number}) {
        return this.put(this.url + '/api/v1/game-process/next', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    goPrevStage(data: {mapId: number, timer?: number}) {
        return this.put(this.url + '/api/v1/game-process/prev', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    finishGame(data: {gameId: number}) {
        return this.put(this.url + '/api/v1/game-process/finish-game', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    getVotes(data: {zoneId: number}) {
        return this.get(this.url + '/api/v1/game-process/express-votes', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    replayGame(data: {zoneId: number}) {
        return this.put(this.url + '/api/v1/game-process/replay-champ', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    skipChamp(data: {zoneId: number}) {
        return this.put(this.url + '/api/v1/game-process/skip-champ', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    backSlide(data: {zoneId: number}) {
        return this.put(this.url + '/api/v1/game-process/back-slide', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    continueGame(data: {gameId: number}) {
        return this.put(this.url + '/api/v1/game-process/resume-champ', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    stopGame(data: {gameId: number}) {
        return this.put(this.url + '/api/v1/game-process/pause-champ', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    geigerCheckUser() {
        return this.post(this.url + '/api/v1/game-process/geiger-check-user', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }
    geigerSendStat(data: {gameId: number}) {
        return this.put(this.url + '/api/v1/game-process/geiger-stat', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }
}

export {GameVarsApi};
